import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { InstallationinspectionInfoPluginService } from './installation-inspection-info.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';

@Component({
    selector: 'installation-inspection-info-edit',
    templateUrl: './installation-inspection-info-edit.component.html',
    standalone: false
})
export class InstallationInspectionInfoEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  @ViewChild('subTypeModal', { static: true })
  subTypeModal: ModalComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    protected pluginService: InstallationinspectionInfoPluginService,
    location: Location,
    protected cdRef: ChangeDetectorRef
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateInspectionInfo(this.inspectionId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public openSubTypeSelector(): void {
    const control = <UntypedFormControl>this.editForm.controls['InterventionType'];
    this.openSelector(this.subTypeModal, this.pluginService.getSubTypes(), control.value);
  }

  public selectSubTypeMenu(item: any) {
    const control = <UntypedFormControl>this.editForm.controls['InterventionType'];
    control.setValue(item.selectedIndex);
    control.markAsTouched();
  }

  public onSubTypeMenuClose() {
    const control = <UntypedFormControl>this.editForm.controls['InterventionType'];
    control.markAsTouched();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      StartDate: new UntypedFormControl(this.plugin.config.StartDate),
      EndDate: new UntypedFormControl(this.plugin.config.EndDate),
      InterventionType: new UntypedFormControl(this.plugin.config.InterventionType)
    });
  }
}
